
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  Box, 
  List, 
  ListItem, 
  ListItemButton, 
  ListItemIcon, 
  ListItemText,
  Typography 
} from '@mui/material';
import { Row, Col, Spin } from 'antd';
import {
  Assessment as AssessmentIcon,
  TrendingUp as TrendingUpIcon,
  BubbleChart as BubbleChartIcon,
  BarChart as BarChartIcon,
  DataArray as DataArrayIcon,
  Description,
  DashboardOutlined,
} from '@mui/icons-material';

const menuItems = [
  { label: 'Data Quality', icon: AssessmentIcon, Description:'Dataset Health' },
  { label: 'Coverage Trends', icon: TrendingUpIcon, Description:'Historical coverage analysis' },
  { label: 'Peer Group Analysis', icon: BubbleChartIcon,Description:'Distribution patterns' },
  { label: 'Volume Metrics', icon: BarChartIcon , Description:'Volume Analysis & Statistics'},
  // { label: 'Data Types', icon: DataArrayIcon, Description:'Schema & type overview' },
];

export const Sidebar = (props) => {

  return (
    <Box
      // sx={{
      //   width: '270px',
      //   backgroundColor: 'var(--dark9)',
      //   borderRight: '1px solid #334155',
      //   display: 'flex',
      //   flexDirection: 'column',
      //   height:'100vh',
      // }}
    >
      {/* <Box sx={{ p: 3, borderBottom: '1px solid #334155', display:'flex',justifyContent:'flex-start' }}>
        <DashboardOutlined style={{marginTop:'4px',fontSize:'24px'}} /> <Typography style={{fontWeight:'500'}} variant="h2">DataScope</Typography>
      </Box> */}
      
      <List sx={{ flex: 1, p: 1 }}>
        {menuItems.map((item) => {
          const Icon = item.icon;
          
          return (
            <ListItem key={item.path} disablePadding sx={{ mb: 0.5 }} disabled = {props.loader}>
              <ListItemButton
                disabled = {props.loader}
                onClick={() => {props.onModuleChange(item.label)}}
                sx={{
                  borderRadius: '0.5rem',
                  mx: 1,
                  bgcolor: props.activeModule == item.label ? '#e5e087' : 'transparent',
                  color: props.activeModule == item.label ? 'black' : 'var(--textPrimary)',
                  '&:hover': {
                    // bgcolor: props.activeModule == item.label ? '#e5e087' : '#e5e087',
                    bgcolor: '#e5e087',
                    color: 'black',
                  },
                }}
              >
                <ListItemIcon sx={{ minWidth: '40px' }}>
                  <Icon sx={{ 
                    color: props.activeModule == item.label ? 'black' : '#94a3b8', fontSize: '2.5rem' }} />
                </ListItemIcon>
                <Col span={24}>
                <ListItemText
                //   primary={item.label}
                  primaryTypographyProps={{
                    fontSize: '0.875rem',
                    maxWidth: '180px',
                    fontWeight: 500,
                    // backgroundColor: isActiveTab == item.label ? '#e5e087':'transparent'
                    // color: isActiveTab == item.label ? '#balck' : '#f8fafc',
                  }}
                >
                    {/* <Col span={24}> */}
                        <Typography style={{fontWeight:props.activeModule == item.label?'450':'300'}} variant='h4'>{item.label}</Typography>
                        <Typography style={{fontWeight:props.activeModule == item.label?'450':'300'}} variant='h6'>{item.Description}</Typography>
                    {/* </Col> */}
                </ListItemText>
                </Col>
              </ListItemButton>
            </ListItem>
          );
        })}
        <ListItem disablePadding sx={{ mb: 0.5 }} disabled = {props.loader}>
          <ListItemButton>
              <Col span={24}>
                <ListItemIcon sx={{ minWidth: '40px', display: 'flex', justifyContent: 'center' }}>
                  <Spin spinning={props.loader} size='large' />
                </ListItemIcon>
              </Col>
            </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );
};
